import { WeightTrendCard } from '../components/WeightTrendCard.js';
import { useProfile } from '../hooks/useProfile.js';

export default function WeightPage() {
  const { data: profile } = useProfile();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h2 className="text-xl font-medium tracking-tight">Weight trend</h2>
        <p className="mt-1 text-sm leading-6 text-ink-soft">
          Log scale weight and follow the smoothed trend line.
        </p>
      </div>
      <WeightTrendCard profile={profile} />
    </div>
  );
}
